export default [
    {
        title: 'CHECKS',
        fields: [
            {
                title: 'Cross Section',
                specs: [
                    {
                        text: 'Downstream Reach Length vs River Stationing',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Thalweg within Bank Stations',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cross Section Spacing - Channel DS Reach Length',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Cross Section Spacing - Head Loss',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cross Section Spacing - Conveyance Ratio',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Cross Section Spacing - Change in Velocity Head',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Cross Section Spacing - Change in Water Depth',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Cross Section Spacing - Change in Floodplain Topwidth',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Cross Section Spacing - Upstream Distance from Critical Depth Cross Section',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Downstream Reach Length of Channel vs Left/Right Overbanks',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'The Length across the Junction',
                        rasReview: false,
                        checkRas: true
                    },
                ]
            },
            {
                title: 'Structure',
                specs: [
                    {
                        text: 'Contraction/Expansion Ratio around Structures',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Bridge Modeling Methods',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Structure Fits between Bounding Cross Sections',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Structure Overflow Consistently at US/DS Cross Sections',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Distance between US/DS to Structure vs Height of the Opening',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Culvert entrance and exit loss coefficients',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'The Culvert Manning\'s n value',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Deck/roadway data is aligned properly with the ground data',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'The low chord line crosses the ground line at more than two locations',
                        rasReview: false,
                        checkRas: true
                    },
                ]
            },
            {
                title: 'Manning\'s n and Transition Coefficients',
                specs: [
                    {
                        text: 'Contraction/Expansion Coefficients',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Manning\'s n Coefficients within Natural Limits',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Manning\'s n Coefficients within Channel is not bigger than Overbanks',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Manning\'s n Coefficients around Structures',
                        rasReview: false,
                        checkRas: true
                    },
                ]
            },
            {
                title: 'Schematic',
                specs: [
                    {
                        text: 'Georeferencing of Cross Sections',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Stream Centerline is between Bank Stations ',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cutline Length is equal to XS Length (r = 1)',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cross Section Cutline is perpendicular to the Stream Centerline (Skew Angle)',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cross Section Cutlines do not intersect each other',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cross Section Cutlines intersect the Stream Centerline',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Schematic river stations vs assigned River Stations of Cross Sections',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Flow',
                specs: [
                    {
                        text: 'Floodway and 100 yr Flow Discharges are consistent',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Floodway and 100 yr Boundary Consitions are consistent',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'The starting water-surface elevation of the floodway profile',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Flow decreases with increasing River Stations',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'The same discharge is used at the US and DS side of a structure',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'A constant discharge is used for the entire profile',
                        rasReview: false,
                        checkRas: true
                    },
                ]
            },
            {
                title: 'Floodway',
                specs: [
                    {
                        text: 'Surchages are within limits',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Encroachment Stations are placed properly',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Encroachment Method',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'The difference in conveyance between the floodway profile and the natural profile',
                        rasReview: false,
                        checkRas: true
                    },
                ]
            },
            {
                title: 'Output',
                specs: [
                    {
                        text: 'Flow Contained within XS',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'XS End Point Elevations are higher than WSEL of Profiles',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Crossing WSEL profiles',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Choking WSEL profiles',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Larger Top Width of a profile with a higher discharge',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Discharge shift between the left and right overbanks across consecutive cross sections.',
                        rasReview: false,
                        checkRas: true
                    },
                ]
            },
        ]
    },
    {
        title: 'COMPARISONS',
        fields: [
            {
                title: 'Cross Section',
                specs: [
                    {
                        text: 'Added/Removed Cross Sections',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Cross Section Station Elevation',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Downstream Reach Length',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Structure',
                specs: [
                    {
                        text: 'Added/Removed Structure',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Structure Geometry',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Bridge Modeling Approach',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Manning\'s n and Transition Coefficients',
                specs: [
                    {
                        text: 'Manning\'s n Coefficients',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Contraction/Expansion Coefficients',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Schematic',
                specs: [
                    {
                        text: 'Georeferencing of Cross Section Cutlines',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Georeferencing of Reach Invert Line',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Ineffective/Obstructed Area',
                specs: [
                    {
                        text: 'Ineffective Areas',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Obstructed Areas',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Flow',
                specs: [
                    {
                        text: 'Discharge Table',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Boundary Conditions',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Floodway',
                specs: [
                    {
                        text: 'Encroachment Stations',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
            {
                title: 'Output',
                specs: [
                    {
                        text: '100yr WSEL',
                        rasReview: true,
                        checkRas: false
                    },
                ]
            },
        ]
    },
    {
        title: 'FEATURES',
        fields: [
            {
                title: 'Features',
                specs: [
                    {
                        text: 'Automated Plan Labeling',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Automated Profile Labeling',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Setting for Thresholds, Defaults and Decimal Places',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Visual Comparison',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Reporting in PDF',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Reporting in MS Word',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Ordering the Findings by ascending/descending River Station',
                        rasReview: true,
                        checkRas: true
                    },
                    {
                        text: 'Flagging the Messages',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Sorting Messages by Message ID or River Station',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Require HEC-RAS model installed',
                        rasReview: false,
                        checkRas: true
                    },
                    {
                        text: 'Require an Output File preperation',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Number of Plans',
                        rasReview: 'all plans',
                        checkRas: 'only current plan'
                    },
                    {
                        text: 'Number of Profiles',
                        rasReview: 'all profiles',
                        checkRas: 'upto seven'
                    },
                    {
                        text: 'Idenfity the Project Reach by Comparing Base and Comparison Plans',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Select a Project Reach and Filter/Highlight Findings within the Project Reach',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Check Calculation Tolerances for a Plan',
                        rasReview: true,
                        checkRas: false
                    },
                    {
                        text: 'Compare Calculation Tolerances between Plans',
                        rasReview: true,
                        checkRas: false
                    },

                ]
            },
        ]
    }
]